import styled from 'styled-components';

export default function Header() {
	return (
		<>
			<Wrapper>
				<Logo src="https://laplust.com/wp-content/themes/laplust2022/images/logo.png" alt="" />
			</Wrapper>
		</>
	)
}

const Wrapper = styled.div`
	padding: 16px;
`

const Logo = styled.img`
	width: 110px;
	height: auto;
`